import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '@/theme/scalingTokens';

export const useBookAnotherCardStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalM,
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: tokens.colorBrandBackground2Hover,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius('0.5rem'),
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalL),
    [mq.tablet]: {
      flexDirection: 'row',
      alignItems: 'center',
      rowGap: 0,
      ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    },
    [mq.smallTablet]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      columnGap: 0,
      rowGap: tokens.spacingVerticalS,
    },
  },
  icon: {
    width: '2rem',
    height: '2rem',
    flexShrink: 0,
  },
  copy: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    rowGap: 0,
    minWidth: 0,
  },
  title: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    lineHeight: tokens.lineHeightBase300,
    margin: 0,
  },
  description: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground2,
    lineHeight: tokens.lineHeightBase200,
    margin: 0,
  },
  bookButton: {
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    [mq.smallTablet]: {
      width: '100%',
      minWidth: 0,
    },
  },
  plusGlyph: {
    display: 'inline-block',
    fontSize: '1.4em',
    fontWeight: tokens.fontWeightBold,
    lineHeight: 1,
    marginRight: '0.4em',
    verticalAlign: '-0.05em',
  },
});
